/**
 * Created by Carsten Bühler
 * User: c.buehler on 11.04.2017
 * Copyright: xdot GmbH 2015
 */
import React from 'external/react';
import PropTypes from 'external/prop-types';

import translationUtil from '../utils/translation';

const LiferayFormComponent = ({ formData, formValidation, propName, required, className, children }) => {
    return (
        <div
            className={'control-group input-String-wrapper ' + (propName ? ' ' + propName + ' ' : '') + (className ? className : '') + (formData && formValidation && propName && formValidation[ propName ] && formValidation[ propName ].length ? ' error' : '')}>
            <label className="control-label">
                {translationUtil.trans(propName) + ' '}
                {required && <span className="label-required">(Erforderlich)</span>}
            </label>
            {children && children}
            {formData && formValidation && propName && formValidation[ propName ] && formValidation[ propName ].length > 0 &&
            <div className="form-validator-stack help-inline">
                <div role="alert" className="required">{formValidation[ propName ]}</div>
            </div>}
        </div>
    );
};


LiferayFormComponent.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array,
        PropTypes.element
    ]),
    formData: PropTypes.object,
    propName: PropTypes.string,
    formValidation: PropTypes.object,
    required: PropTypes.bool,
    className: PropTypes.string
};


export default LiferayFormComponent;



// WEBPACK FOOTER //
// ./js/components/LiferayFormComponent.jsx